import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import Modal from "react-bootstrap/Modal";
import ReactPlayer from "react-player";

const videoSlides = [
  {
    id: 1,
    className: "slider1",
    url: "https://www.youtube.com/watch?v=UGa6jC27_Bc",
  },
  {
    id: 2,
    className: "slider2",
    url: "https://www.youtube.com/watch?v=agDUVzH9LNc",
  },
  {
    id: 3,
    className: "slider3",
    url: "https://www.youtube.com/watch?v=09YGeX_OiEU",
  },
  {
    id: 4,
    className: "slider4",
    url: "https://www.youtube.com/watch?v=Dq-GvEAwIGE",
  },
  {
    id: 5,
    className: "slider5",
    url: "https://www.youtube.com/watch?v=PhUpQL1Lg2A",
  },
];

export default function App() {
  const [show, setShow] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [playing, setPlaying] = useState(false);

  const handleShow = (url) => {
    setCurrentVideo(url);
    setShow(true);
    setPlaying(true);
  };

  const handleClose = () => {
    setShow(false);
    setPlaying(false);
  };

  useEffect(() => {
    if (show) {
      setPlaying(true);
    } else {
      setPlaying(false);
    }
  }, [show]);

  return (
    <>
      <Modal centered size="lg" show={show} onHide={handleClose}>
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="slider-model">
          <ReactPlayer
            url={currentVideo}
            playing={playing}
            controls={true}
            width="100%"
            height="100%"
            muted={false}
            onReady={() => {
              if (show) {
                setPlaying(true);
              }
            }}
            onEnded={() => setPlaying(false)}
          />
        </Modal.Body>
      </Modal>

      <Swiper
        effect="coverflow"
        grabCursor={false}
        loop={true}
        spaceBetween={70}
        slidesPerView={1}
        centeredSlides={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 0.5,
          slideShadows: true,
        }}
        navigation={true}
        breakpoints={{
          640: { slidesPerView: 1, centeredSlides: true },
          768: { slidesPerView: 1, centeredSlides: false },
          1024: { slidesPerView: 3, centeredSlides: false },
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="mySwiper"
      >
        {videoSlides.map((slide) => (
          <SwiperSlide key={slide.id} className={slide.className}>
            <div
              className="slider-overlayer"
              onClick={() => handleShow(slide.url)}
            >
              <ReactPlayer
                url={slide.url} // YouTube URL, `react-player` converts it to embed
                className="background-video"
                width="100%" // Adjust width
                height="100%" // Adjust height
                light={true} // Use a thumbnail preview
                playing={false} // Don't auto-play videos in the thumbnail
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
